import React from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Form,
  reduxForm,
  Field,
  formValueSelector,
  change,
  getFormValues
} from 'redux-form'

import { makeStyles, styled, useTheme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { Tooltip, useMediaQuery } from '@material-ui/core'
import StyledSVG from '../shared/StyledSVG'
import UserAvatar from '../shared/UserAvatar'

import { showAlertMessage } from '../../store/alert/actions'
import { removeDoormanRSPA } from '../../store/doormen/actions'

import Modal from '../modal/Modal'
import CustomTable from '../table/CustomTable'
import Button from '../button/Button'
import MaterialInput from '../shared/MaterialInput'
import editIntoModalSVG from '../../assets/icons/edit-pencil.svg'
import filterSVG from '../../assets/icons/filter-icon.svg'
import deleteSVG from '../../assets/icons/pattern-delete-icon.svg'
import trashSVG from '../../assets/icons/ilustration-trash.svg'
import editSVG from '../../assets/icons/pattern-edit-icon.svg'
import viewSVG from '../../assets/icons/pattern-view-icon.svg'
import studentBookSVG from '../../assets/icons/student-details-icon.svg'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded'

const AdvancedFilter = styled('div')(
  ({ theme, openMoreFilter, ltThousand }) => {
    return {
      transition: 'height 0.5s ease-in-out',
      height: openMoreFilter ? (ltThousand ? '370px' : '175px') : '0px',
      [theme.breakpoints.down(1000)]: {
        overflow: 'auto'
      }
    }
  }
)

const useStyles = makeStyles(theme => ({
  bottom_btns_wrapper: {
    marginTop: 18,
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'center',
    textAlign: 'right',
    gap: 10,
    [theme.breakpoints.down('1000')]: {
      flexDirection: 'column',
      alignItems: 'center',
      '& button': {
        width: 240
      }
    }
  },
  textModal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  modal_cancel_btn: {
    backgroundColor: '#EF7C8F',
    width: 136,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  modal_confirm_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 165,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  filled_btn: {
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  create_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 250,
    height: 48,
    '&:hover': {
      backgroundColor: '#386093'
    }
  },
  back_btn: {
    width: 146,
    border: '1px solid #EF7C8F',
    height: 48,
    padding: '14px 48px',
    gap: 10,
    color: '#EF7C8F',
    borderRadius: 8,
    '&:hover': {
      border: '1px solid #EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  reactiveBtn: {
    backgroundColor: '#F4A87C',
    width: 247,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  actionsSection: {
    display: 'flex',
    gap: 5,
    alignItems: 'center',
    width: '55%',
    '& svg': {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    '& path': {
      stroke: '#868E96'
    }
  },
  root: {
    width: '100%',
    padding: '40px 30px',
    height: '100%',
    borderRadius: 8,
    backgroundColor: '#FFFFFF'
  },
  page_label: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: 20,
    '& h1': {
      fontSize: 32,
      color: '#386093',
      fontWeight: 700,
      margin: 0
    },
    '& p': {
      fontSize: 16,
      color: '#555555',
      fontWeight: 400,
      margin: 0
    }
  },
  filters_wrapper: {
    marginTop: 40
  },
  search_field: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: 8,
    '& .label': {
      margin: 0,
      fontWeight: 700,
      fontSize: 12
    },
    '& .MuiInputBase-root': {
      width: 395,
      [theme.breakpoints.down('426')]: {
        maxWidth: '250px'
      },
      [theme.breakpoints.down('330')]: {
        maxWidth: 220
      }
    }
  },
  filters_section: {
    display: 'flex',
    flexDirection: 'column'
  },
  filter_label: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  filters_display: {
    display: 'flex',
    flexDirection: 'column'
  },
  search_group: {
    marginTop: 16,
    transition: 'opacity 0.3s ease-in-out',
    display: 'flex',
    gap: 24,
    [theme.breakpoints.down('1000')]: {
      flexDirection: 'column',
      gap: 12
    }
  },
  filter_buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    gap: 8,
    '& button': {
      marginRight: 0,
      width: 149
    },
    [theme.breakpoints.down('1000')]: {
      justifyContent: 'flex-start',
      marginTop: 15,
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& button': {
        width: '200px !important'
      }
    },
    [theme.breakpoints.down('350')]: {
      '& button': {
        width: '170px !important'
      }
    }
  },
  clear_btn: {
    backgroundColor: '#EF7C8F',
    width: 154,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  apply_btn: {
    backgroundColor: '#386093',
    width: 154,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  horizontal_bar: {
    marginBottom: 27,
    width: '96%',
    height: 1,
    border: '1px solid #ADB8CC'
  },
  user_detail_root: {
    padding: '40px',
    position: 'relative'
  },
  close_icon: {
    position: 'absolute',
    top: 10,
    right: 10
  },
  user_data_header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
    [theme.breakpoints.down('500')]: {
      justifyContent: 'center'
    }
  },
  user_data_label: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    columnGap: 20,
    '& h1': {
      fontSize: 24,
      fontWeight: 700,
      color: '#386093',
      [theme.breakpoints.down('360')]: {
        fontSize: 19
      }
    }
  },
  info_label: {
    display: 'flex',
    justifyContent: 'flex-start',
    '& span': {
      color: '#555555',
      fontSize: 16
    }
  },
  user_type: {
    marginBottom: 20,
    '& span': {
      fontSize: '18px !important',
      fontWeight: '600 !important',
      color: '#386093 !important'
    }
  },
  personal_data: {
    marginBottom: 10,
    color: '#555555',
    fontWeight: 600
  },
  user_info: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& label': {
      color: '#9F9F9F',
      fontWeight: 500,
      fontSize: 16
    },
    '& p': {
      margin: 0,
      color: '#666666',
      fontWeight: 700,
      fontSize: 16
    }
  },
  edit_btn_wrapper: {
    '& button': {
      border: '2px solid #386093',
      color: '#386093',
      borderRadius: 8,
      '&:hover': {
        backgroundColor: 'transparent',
        border: '2px solid #386093'
      }
    }
  },
  edit_btn: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    color: '#386093'
  },
  avatar_wrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    justifyContent: 'flex-start'
  },
  table_wrapper: {
    marginTop: 56,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 24,
    '& .table_label': {
      fontWeight: 600,
      fontSize: 20,
      color: '#386093',
      margin: 0
    }
  },
  trash_icon_wrapper: {
    '& svg': {
      '& path': {
        stroke: '#EF7C8F'
      }
    }
  },
  remove_doorman_modal: {
    padding: '40px 56px',
    width: 650,
    height: 480
  },
  remove_doorman_description: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    '& h1': {
      margin: 0,
      color: '#386093',
      fontWeight: 600,
      fontSize: 24
    },
    '& p': {
      margin: 0,
      color: '#9B9B9B',
      fontWeight: 600,
      fontSize: 16,
      '& .strong': {
        color: '#7B7B7B'
      }
    }
  },
  remove_doorman_btns_wrapper: {
    marginTop: 32,
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: 24
  },
  remove_doorman_cancel: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 220,
    height: 48,
    '&:hover': {
      backgroundColor: '#386093'
    }
  },
  remove_doorman_btn: {
    backgroundColor: '#EF7C8F',
    color: '#FFFF',
    width: 220,
    height: 48,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    }
  }
}))

const SearchDoormanForm = ({
  doormen,
  getDoormen,
  nameValue,
  emailValue,
  school,
  touch,
  change,
  removeDoormanRSPA,
  reset,
  alert
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const ltThousand = useMediaQuery(theme.breakpoints.down(1000))
  const history = useHistory()
  const defaultParams = { 'q[school_id_eq]': school?.school_id }
  const [searchParams, setSearchParams] = React.useState({})
  const [openMoreFilter, setOpenMoreFilter] = React.useState(false)
  const [removeDoormanModal, setRemoveDoormanModal] = React.useState({
    isOpen: false,
    school_doorman_id: null,
    name: ''
  })
  const [userDetailModal, setUserDetailModal] = React.useState({
    isOpen: false,
    current: null
  })
  const selectNameRef = React.useRef(null)
  const selectEmailRef = React.useRef(null)
  const columns = [
    {
      key: 'name',
      name: 'Nome',
      width: '35%',
      render: row => {
        const userName = row.doorman.name
        const userAvatar = row.doorman.avatar_url
        return (
          <div className={classes.avatar_wrapper}>
            <UserAvatar
              avatarUrl={userAvatar}
              userName={userName}
              withoutUserName
            />
            <p>{userName}</p>
          </div>
        )
      }
    },
    {
      key: 'taxpayer_number',
      name: 'CPF',
      width: '15%',
      render: row => {
        return row.doorman?.taxpayer_number
      }
    },
    {
      key: 'phone',
      name: 'Telefone',
      width: '15%',
      render: row => {
        return row.doorman?.phone
      }
    },
    {
      key: 'email',
      name: 'Email',
      width: '25%',
      render: row => {
        return row.doorman?.email
      }
    },
    {
      key: 'actions',
      name: '',
      width: '10%',
      align: 'right',
      render: function render (row) {
        return (
          <div className={classes.actionsSection}>
            <Tooltip title='Visualizar'>
              <div
                onClick={() => {
                  handleUserDetails(row)
                }}
              >
                <StyledSVG src={viewSVG} width={20} height={20} />
              </div>
            </Tooltip>
            <Tooltip title='Editar'>
              <div
                onClick={() =>
                  history.push(`${history.location.pathname}/${row.user_id}`)
                }
              >
                <StyledSVG src={editSVG} width={20} height={20} />
              </div>
            </Tooltip>
            <Tooltip title='Remover controlador'>
              <div
                onClick={() =>
                  setRemoveDoormanModal({
                    isOpen: true,
                    school_doorman_id: row.id,
                    name: row?.doorman?.name
                  })
                }
                className={classes.trash_icon_wrapper}
              >
                <StyledSVG src={deleteSVG} width={20} height={20} />
              </div>
            </Tooltip>
          </div>
        )
      }
    }
  ]

  React.useEffect(
    () => {
      setSearchParams(prev => ({
        ...(nameValue ? { 'q[doorman_name_cont]': nameValue } : {}),
        ...(emailValue ? { 'q[doorman_email_cont]': emailValue } : {}),
        'q[school_id_eq]': school?.school_id,
        'q[s]': 'created_at desc'
      }))
    },
    [nameValue, emailValue]
  )

  const handleCloseRemoveDoormanModal = () => {
    setRemoveDoormanModal({
      isOpen: false,
      name: '',
      school_doorman_id: null
    })
  }

  const handleSearch = () => {
    getDoormen({ params: { ...searchParams, ...defaultParams } })
  }
  const handleUserDetails = row => {
    setUserDetailModal(prev => ({ isOpen: !prev.isOpen, current: row }))
  }

  const handleClearFields = () => {
    reset()
    selectNameRef.current?.select.clearValue()
    selectEmailRef.current?.select.clearValue()
    getDoormen({
      params: {
        ...defaultParams,
        'q[s]': 'created_at desc'
      }
    })
  }

  const handleChangeTitle = event => {
    if (event.keyCode === 13 && event.shiftKey === false) {
      getDoormen({ params: { ...searchParams, ...defaultParams } })
    }
  }

  const handleConfirmRemoveDoorman = async id => {
    await removeDoormanRSPA({ school_doorman_id: id })
      .then(res => {
        alert('Controlador removido com sucesso!', 'success')
      })
      .catch(error => {
        alert('Erro ao remover controlador.', 'error')
        console.error(error)
      })
      .finally(() => {
        handleCloseRemoveDoormanModal()
        setTimeout(() => {
          getDoormen({ params: { ...searchParams, ...defaultParams } })
        }, 1000)
      })
  }

  return (
    <div className={classes.root}>
      <Form>
        <div className={classes.page_label}>
          <h1>Controlador</h1>
          <p>
            Acompanhe todas as retiradas realizadas na escola e gere relatórios
            de segurança e presença.
          </p>
        </div>
        <div className={classes.filters_wrapper}>
          <div className={classes.search_field}>
            <p className='label'>Busca</p>
            <Field
              component={MaterialInput}
              selectRef={selectNameRef}
              name='name'
              endBtnFunction={() => {
                getDoormen({ params: { ...searchParams, ...defaultParams } })
              }}
              onKeyDown={handleChangeTitle}
              placeholder={'Buscar pelo nome do controlador'}
              type='text'
            />
          </div>
          <div className={classes.filters_section}>
            <div className={classes.filter_label}>
              <StyledSVG src={filterSVG} width={12} height={12} />
              <p
                onClick={() => setOpenMoreFilter(prev => !prev)}
                style={{
                  cursor: 'default',
                  fontWeight: 700,
                  fontSize: 12,
                  color: '#386093'
                }}
              >
                Filtros avançados
              </p>
              {!openMoreFilter ? (
                <KeyboardArrowDownIcon
                  onClick={() => setOpenMoreFilter(prev => !prev)}
                  style={{ height: 12, width: 12 }}
                />
              ) : (
                <KeyboardArrowUpIcon
                  onClick={() => setOpenMoreFilter(prev => !prev)}
                  style={{ height: 12, width: 12 }}
                />
              )}
            </div>
            <AdvancedFilter
              ltThousand={ltThousand}
              openMoreFilter={openMoreFilter}
            >
              <div className={classes.filters_display}>
                <div
                  className={classes.search_group}
                  style={{ opacity: openMoreFilter ? '1' : '0' }}
                >
                  <div className={classes.search_field}>
                    <p className='label'>E-mail</p>
                    <Field
                      component={MaterialInput}
                      name='email'
                      selectRef={selectEmailRef}
                      placeholder='Digite um nome'
                      type='email'
                    />
                  </div>
                </div>
                <div
                  style={{
                    opacity: openMoreFilter ? '1' : '0',
                    transition: 'opacity 0.3s ease-in-out'
                  }}
                  className={classes.filter_buttons}
                >
                  <Button
                    onClick={() => handleClearFields()}
                    className={classes.clear_btn}
                  >
                    Limpar
                  </Button>
                  <Button
                    className={classes.apply_btn}
                    type='button'
                    onClick={() => handleSearch()}
                  >
                    Aplicar
                  </Button>
                </div>
              </div>
            </AdvancedFilter>
          </div>
          <div className={classes.horizontal_bar} />
        </div>
        <div>
          <h1 className='table_label'>Resultados</h1>
          <CustomTable
            columns={columns}
            border={'none'}
            bodyBorder={'none'}
            headCellRadius
            headColor={'rgba(173, 184, 204, 0.3)'}
            data={doormen.items}
            params={{ ...searchParams, ...defaultParams }}
            fetchItems={getDoormen}
            isFetching={doormen.isFetching}
            pagination={doormen.pagination}
          />
        </div>
        <div>
          <Grid item xs={12} className={classes.bottom_btns_wrapper}>
            <Button
              className={classes.back_btn}
              variant='outlined'
              type='button'
              onClick={() => history.push('/settings')}
            >
              Voltar
            </Button>
            <Button
              className={`${classes.filled_btn} ${classes.create_btn}`}
              type='button'
              onClick={() =>
                history.push(`${history.location.pathname}/create`)
              }
            >
              Cadastrar porteiro
            </Button>
          </Grid>
        </div>
        <Modal
          open={removeDoormanModal.isOpen}
          handleClose={handleCloseRemoveDoormanModal}
          disablePadding
        >
          <div className={classes.remove_doorman_modal}>
            <StyledSVG src={trashSVG} width={160} height={160} />
            <div className={classes.remove_doorman_description}>
              <h1>Remover função de controlador ?</h1>
              <p>
                Você está prestes a remover{' '}
                <span className='strong'>{removeDoormanModal?.name}</span> da
                função de controlador. O usuário continuará ativo no sistema.
              </p>
            </div>
            <div className={classes.remove_doorman_btns_wrapper}>
              <Button
                onClick={handleCloseRemoveDoormanModal}
                className={` ${classes.filled_btn} ${
                  classes.remove_doorman_cancel
                }`}
                type='button'
              >
                Cancelar
              </Button>
              <Button
                className={`${classes.filled_btn} ${
                  classes.remove_doorman_btn
                }`}
                type='button'
                onClick={() =>
                  handleConfirmRemoveDoorman(
                    removeDoormanModal.school_doorman_id
                  )
                }
              >
                Remover função
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          open={userDetailModal.isOpen}
          handleClose={() =>
            handleUserDetails({ isOpen: false, current: null })
          }
          width={'85%'}
          disablePadding
        >
          <div className={classes.user_detail_root}>
            <CloseRoundedIcon
              onClick={() =>
                handleUserDetails({ isOpen: false, current: null })
              }
              className={classes.close_icon}
            />
            <Grid className={classes.user_data_header} container item>
              <div className={classes.user_data_label}>
                <StyledSVG src={studentBookSVG} />
                <h1>Dados cadastrais</h1>
              </div>
              <div className={classes.edit_btn_wrapper}>
                <Button variant='outlined'>
                  <div
                    className={classes.edit_btn}
                    onClick={() => {
                      history.push(
                        `${history.location.pathname}/${
                          userDetailModal?.current?.id
                        }/edit`
                      )
                    }}
                  >
                    <StyledSVG width={14} height={14} src={editIntoModalSVG} />
                    <span>Editar</span>
                  </div>
                </Button>
              </div>
            </Grid>
            <Grid container style={{ rowGap: '10px' }}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className={`${classes.info_label} ${classes.user_type}`}>
                  <span>Controlador</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div
                  className={`${classes.info_label} ${classes.personal_data}`}
                >
                  <span>Dados pessoais</span>
                </div>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <div className={classes.user_info}>
                    <label>Nome do controlador</label>
                    <p>{userDetailModal?.current?.doorman?.name}</p>
                  </div>
                </Grid>
                {userDetailModal?.current?.doorman?.taxpayer_number && (
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <div className={classes.user_info}>
                      <label>CPF</label>
                      <p>
                        {userDetailModal?.current?.doorman?.taxpayer_number}
                      </p>
                    </div>
                  </Grid>
                )}
                {userDetailModal?.current?.doorman?.email && (
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <div className={classes.user_info}>
                      <label>E-mail</label>
                      <p>{userDetailModal?.current?.doorman?.email}</p>
                    </div>
                  </Grid>
                )}
                {userDetailModal?.current?.doorman?.phone && (
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <div className={classes.user_info}>
                      <label>Contato</label>
                      <p>{userDetailModal?.current?.doorman?.phone}</p>
                    </div>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </div>
        </Modal>
      </Form>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('searchDoormanForm')
  return {
    nameValue: selector(state, 'name'),
    emailValue: selector(state, 'email'),
    fieldValues: getFormValues('searchDoormanForm')(state)
  }
}

const mapDispatchToProps = dispatch => ({
  removeDoormanRSPA: data => dispatch(removeDoormanRSPA.request(data)),
  change: (field, data) => dispatch(change('searchDoormanForm', field, data)),
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'searchDoormanForm'
  })(SearchDoormanForm)
)
